export const getPastYearsForDropdown = (harvestYear: number) =>
  Array.from({ length: 20 }, (_, i) => ({
    label: (harvestYear - 1 - i).toString(),
    value: (harvestYear - 1 - i).toString(),
  }));
